import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { useGetStoreList } from "../../../hooks/api/queries";

export const useStockTransfer = ({ setTransferData, otherTransferInfo }) => {
  const [search, setSearch] = useSearchParams();
  const { storeList } = useSelector((state) => state.profileDetailsReducer);
  const { data: generalStoreList, isLoading: isFetchingGeneralStores } =
    useGetStoreList({
      queryParams: { all_stores: true },
      allowDispatch: false,
    });
  const [storeError, setStoreError] = useState("");
  const handleAppendTransferData = (item) => {
    setTransferData((prevData) => [
      {
        name: item?.name,
        product_id: item?.product_id,
        variant_id: item?.variant_id,
        stock_quantity: item?.stock_quantity,
        variant_name: item?.variant,
        unit: item?.unit,
        quantity: "",
        reference_number: "",
        update_destination_pricing: item?.update_destination_pricing,
        cost_price: item?.cost_price ?? 0,
      },
      ...prevData,
    ]);
  };

  const filterByStore = (value) => {
    search.set("store_id", value);
    setSearch(search, { replace: true });
  };

  useEffect(() => {
    if (
      otherTransferInfo?.transfer_from_store_id &&
      otherTransferInfo?.transfer_from_store_id !== ""
    )
      filterByStore(otherTransferInfo?.transfer_from_store_id);
  }, [otherTransferInfo?.transfer_from_store_id]);

  return {
    storeList,
    storeError,
    search,
    isFetchingGeneralStores,
    generalStoreList,
    setStoreError,
    handleAppendTransferData,
    filterByStore,
  };
};
